/* src/app/pages/ortho/diferencias/diferencias.component.scss */
.diferencias-container {
  background-color: #000000;
}
/*# sourceMappingURL=diferencias.component.css.map */
